class RenderPreController {
	$onInit() {
		if (this.logData) console.log('renderPre > onInit > ', this.itemData); // eslint-disable-line
		// TODO: support more langs snippets this.itemLang = this.itemLang || 'json';
	}

	$onChanges(changesObj) {
		if (changesObj.itemData.currentValue && this.logData) {
			console.log('renderPre > ', changesObj.itemData); // eslint-disable-line
		}
	}
}
//
export const RenderPre = {
	template: `
		<details>
			<summary>JSON Data</summary>
			<pre copy-to-clipboard copy-text="{{$ctrl.itemData}}" class="p-2" style="white-space: pre-wrap; overflow-y: auto;">{{$ctrl.itemData|json}}</pre>
		</details>
	`,
	controller: RenderPreController,
	bindings: {
		itemData: '<',
		logData: '<?',
	},
};
let compMod = angular.module('mod.cmp.renderPre', []).component('renderPre', RenderPre);
export default (compMod = compMod.name);
